import RouterContext from 'contexts/RouterContext';
import React, { Component } from 'react';
import { useSearchParams } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';

type Props = {
    code: string;
}

type State = {}

class RouterProvider extends Component<any, any> {
    state = {
        auth: { code: '' }
    }

    static contextType = AuthContext
    context!: React.ContextType<typeof AuthContext>

    componentDidMount() {
        this.context.login(this.context)
    }

    render() {
        return (<RouterContext.Provider value={'this.state.auth'}>
            {this.props.children}
        </RouterContext.Provider>)
    }
}

function withHooks(RouterProvider: any) {
    return (props: any) => {
        const [searchParams] = useSearchParams();
        return <RouterProvider
            code={searchParams.get('code')}  {...props} />;
    };
}

export default withHooks(RouterProvider)